import React from "react";
import InventoryReport from "./InventoryReports";

// Api/Reports/CustomerCreditRepaymentReport - see InventoryReports.jsx
const CustomerRepayment = () => <InventoryReport kind="repayment" />;

export default CustomerRepayment;
